// pages/TonnageComparisonPage.tsx
import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { useTonnageStatsStore } from '../stores/tonnageStatsStore';
import { useTonnagePanels } from '../hooks/useTonnagePanels';
import { TonnageSelectorsBar } from '../components/TonnageSelectorsBar';
import { TonnagePanelTable } from '../components/TonnagePanelTable';
import Layout from '../../../../../components/custom/Layout';

const PageWrapper = styled.div`
  background: #fff;
`;

const Heading = styled.h2`
  font-size: 14px;
  font-weight: 700;
  padding: 12px 16px 0;
`;

const PanelsRow = styled.div`
  display: flex;
  gap: 16px;
  padding: 16px;
  overflow-x: auto;
`;

export default function TonnageStats() {
    const { dataByYear, yearOne, yearTwo, availableYears, fetchAvailableYears } = useTonnageStatsStore();
    
    useEffect(() => {
        fetchAvailableYears();
        useTonnageStatsStore.getState().ensureYearLoaded(yearOne);
        useTonnageStatsStore.getState().ensureYearLoaded(yearTwo);
    }, []); // run once on mount, after auth interceptor is attached

    const panels = useTonnagePanels();

    const availableUnits = useMemo(() => {
        const set = new Set<string>();
        [...(dataByYear[yearOne] ?? []), ...(dataByYear[yearTwo] ?? [])].forEach((r) => set.add(r.unit));
        return Array.from(set).sort();
    }, [dataByYear, yearOne, yearTwo]);

    const availableAirlines = useMemo(() => {
        const set = new Set<string>();
        [...(dataByYear[yearOne] ?? []), ...(dataByYear[yearTwo] ?? [])].forEach((r) => set.add(r.airlineCode));
        return Array.from(set).sort();
    }, [dataByYear, yearOne, yearTwo]);

    return (
        <Layout>
            <PageWrapper>
                <Heading>Tonnage Comparison Analysis</Heading>
                <TonnageSelectorsBar
                    availableYears={availableYears}
                    availableUnits={availableUnits}
                    availableAirlines={availableAirlines}
                />
                <PanelsRow>
                    <TonnagePanelTable title="Current Week" y1Label={String(yearOne)} y2Label={String(yearTwo)} data={panels.week} />
                    <TonnagePanelTable title="Current Month" y1Label={String(yearOne)} y2Label={String(yearTwo)} data={panels.month} />
                    <TonnagePanelTable title="Current Year" y1Label={String(yearOne)} y2Label={String(yearTwo)} data={panels.year} />
                </PanelsRow>
            </PageWrapper>
        </Layout>
    );
}